import React from "react";

import microsoftIcon from "@iconify/icons-mdi/microsoft";
import { Icon } from "@iconify/react/dist/offline";

import { Button } from "src/components/ui/button";
import { useAzureSSO } from "src/experiences/auth/hooks/useAzureSSO";

export const AzureLoginButton = (): React.ReactElement => {
  const { initiateAzureSSO, loading: azureLoading } = useAzureSSO();

  const handleLogin = () => {
    initiateAzureSSO();
  };

  return (
    <Button
      variant="outline"
      className="w-full"
      onClick={handleLogin}
      disabled={azureLoading}
    >
      <Icon icon={microsoftIcon} className="mr-2 h-4 w-4" />
      Login with Azure SSO
    </Button>
  );
};
